<template>
  <div id="shopping" @click="operaHideShoppingCar">
    <div class="wrap shopping-top">
      <div class="wrap_zh">
        <div class="shopping-top-broadcast fl">
          <img src="../../assets/images/shopping/home_icon_notice.png" alt class="fl">
          <p>梅管家网上商城正式上线啦！</p>
        </div>

        <div class="shopping-canel fr">
          <div class="shopping-canel_user fl">
            <img
              src="../../assets/images/shopping/tingmei.png"
              alt
              class="fl"
              v-if="userInfo.regionNo == 1"
            >
            <img
              src="../../assets/images/shopping/zhenyoutang.png"
              alt
              class="fl"
              v-if="userInfo.regionNo == 2"
            >
            <img
              src="../../assets/images/shopping/meiboshi.png"
              alt
              class="fl"
              v-if="userInfo.regionNo == 3"
            >
            <img
              src="../../assets/images/shopping/zhenyuezi.png"
              alt
              class="fl"
              v-if="userInfo.regionNo == 4"
            >
            <p>{{userInfo.regionName}}</p>
          </div>
          <div class="shopping-canel_out fl">
            <p>
              <router-link to="/">[退出商城]</router-link>
            </p>
          </div>
        </div>
        <div class="shopping-top_nav fr">
          <router-link to="/shoppingMall/shoppingMyOrders">{{userInfo.storeUserName}}</router-link>
          <router-link to="/shoppingMall/shoppingMyOrders">我的订单</router-link>|
          <router-link to="/shoppingMall/shoppingAfterCustomer">售后中心</router-link>|
          <a href="javascript:;">帮助中心</a>|
          <a href="javascript:;">在线客服</a>
        </div>
      </div>
    </div>
    <div class="wrap shopping-head">
      <div class="wrap_zh">
        <div class="shopping-head_logo fl">
          <img
            src="../../assets/images/shopping/tingmei.png"
            alt
            class="shopping-logos fl"
            v-if="userInfo.regionNo == 1"
          >
          <img
            src="../../assets/images/shopping/zhenyoutang.png"
            alt
            class="shopping-logos fl"
            v-if="userInfo.regionNo == 2"
          >
          <img
            src="../../assets/images/shopping/meiboshi.png"
            alt
            class="shopping-logos fl"
            v-if="userInfo.regionNo == 3"
          >
          <img
            src="../../assets/images/shopping/zhenyuezi.png"
            alt
            class="shopping-logos fl"
            v-if="userInfo.regionNo == 4"
          >
          <dl class="shopping-head_dl fr">
            <dt>{{userInfo.storeShopName}}</dt>
            <dd>汇聚优质商品</dd>
          </dl>
        </div>
        <div class="shopping-search fr">
          <div class="shopping-search_input fl">
            <el-input placeholder="请输入内容"></el-input>
          </div>
          <div class="shoppin-search_btn fl">
            <el-button type="danger" @click="operaSearch">
              <img src="../../assets/images/shopping/home_icon_search.png" alt>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapt nav">
      <div class="wrap_zht">
        <div class="nav-list fl">
          <li :class="navIndex == 0 && 'on'" @click="operaNav(0)">
            <router-link to="/shoppingMall/index">首页</router-link>
          </li>
          <li :class="navIndex == 1 && 'on'" @click="operaNav(1)">
            <router-link to="/shoppingMall/shoppingProduct" @click="operaNav(1)">产品</router-link>
          </li>
          <li :class="navIndex == 2 && 'on'" @click="operaNav(2)">
            <router-link to="/shoppingMall/shoppingInstrument" @click="operaNav(2)">仪器</router-link>
          </li>
          <li :class="navIndex == 3 && 'on'" @click="operaNav(3)">
            <router-link to="/shoppingMall/shoppingMateriel" @click="operaNav(3)">物料</router-link>
          </li>
          <li :class="navIndex == 4 && 'on'" @click="operaNav(4)">
            <router-link to="/shoppingMall/shoppingMeal" @click="operaNav(4)">套餐</router-link>
          </li>
          <li :class="navIndex == 5 && 'on'" @click="operaNav(5)">
            <router-link to="/shoppingMall/shoppingConfigure" @click="operaNav(5)">配置</router-link>
          </li>
        </div>
        <div class="nav-shopping-car fr" id="myShoppingCar">
          <!-- on -->
          <div
            :class="shoppingCar && 'on'"
            class="nav-shopping-car_info fl"
            @click="operaShowShoppingCar"
          >
            <img
              src="../../assets/images/shopping/home_icon_down.png"
              alt
              class="nav-shopping-icon fr"
            >
            <span class="fr">
              我的购物车(
              <font>{{$store.state.shoppingNum}}</font>
              )
            </span>
            <img src="../../assets/images/shopping/home_icon_shoppingcart.png" alt class="fr">
          </div>
          <!--无商品-->
          <div class="nav-shopping-car_list fl" v-if="$store.state.shoppingNum < 1 && shoppingCar">
            <div class="nav-shopping-nogoods fl">
              <img src="../../assets/images/shopping/emptypage_shoppingcart.png">
            </div>
            <div class="nav-shopping-nogoodsp fl">
              <p>购物车里还没有商品，快去选购吧！</p>
            </div>
          </div>

          <!--有商品-->
          <div class="nav-shopping-car_list fl" v-if="$store.state.shoppingNum > 0 && shoppingCar">
            <div class="nav-shopping-car_list-ul-scrollbar fl">
              <el-scrollbar style="height: 100%">
                <div class="nav-shopping-car_list-ul fl">
                  <div
                    class="nav-shopping-car_list-ulli fl"
                    v-for="(vals,index) in shoppingList"
                    :key="index"
                  >
                    <img :src="vals.productImgUrl" alt class="shopping-car-img fl">
                    <dl>
                      <dt>{{vals.productName}}</dt>
                      <dd>
                        {{vals.productSpec}}
                        <font>x {{vals.quantity}}</font>
                      </dd>
                    </dl>
                    <p>¥ {{vals.subtotal}}</p>
                    <span @click="operaShoppingCarDelete(vals)">
                      <img src="../../assets/images/shopping/home_icon_delete.png" alt class="fl">
                    </span>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div class="nav-shopping-car_list-bottom fl">
              <div class="nav-shopping-car_bot-l fl">
                <dl>
                  <dt>共 {{$store.state.shoppingNum}} 件商品</dt>
                  <dd>¥ {{shoppingCarAllPrice}}</dd>
                </dl>
              </div>
              <div class="nav-shopping-car_bot-r fr" @click='operaGoShoppingCar'>
                <a href="javascript:;" class="fl">去购物车结算</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 路由切换页面 -->
    <router-view @shoppingCars="operaShoppingCars" />
    <!-- 路由切换页面 -->
    <div class="wrap shopping-consult">
      <div class="wrap_zh">
        <div class="shopping-consult_customer fl">
          <dl>
            <dt>
              <img src="../../assets/images/shopping/home_icon_service.png" alt>
            </dt>
            <dd>在线客服</dd>
          </dl>
        </div>
        <div class="shopping-consult_customer fl">
          <dl>
            <dt>
              <img src="../../assets/images/shopping/home_icon_feedback.png" alt>
            </dt>
            <dd>意见反馈</dd>
          </dl>
        </div>
        <div class="shopping-consult_phone fl">
          <div class="shopping-consult_phone-line fl">
            <img src="../../assets/images/shopping/home_icon_phone.png" alt>
            <span>服务热线：</span>
          </div>
          <div class="shopping-consult_phone-num fl">
            <font>400 0512 996</font>
          </div>
          <div class="shopping-consult_phone-time fl">
            <font>周一至周六 09:00-17:30</font>
          </div>
        </div>
        <div class="shopping-consult_wechat fl">
          <img src="../../assets/images/shopping/androidimg.png" alt class="fl">
          <dl>
            <dt>关注臻幼堂微信公众号</dt>
            <dd>特价活动早知道</dd>
          </dl>
        </div>
        <div class="shopping-consult_nav fr">
          <router-link to="/shoppingMall/shoppingProduct">产品</router-link>|
          <router-link to="/shoppingMall/shoppingInstrument">仪器</router-link>|
          <router-link to="/shoppingMall/shoppingMateriel">物料</router-link>|
          <router-link to="/shoppingMall/shoppingMeal">套餐</router-link>|
          <router-link to="/shoppingMall/shoppingConfigure">配置</router-link>
        </div>
      </div>
    </div>
    <div class="wrap shopping-footer">
      <div class="wrap_zh">
        <p>Copyright © 2017-2020梅氏云服务 版权所有 苏ICP备17044969号-2号</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { selectShopCar, addProductCar, deleteProductCar } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";
export default {
  name: "shopping",
  data() {
    return {
      navIndex: 0,
      userInfo: {
        regionNo: this.$store.state.userInfo.brandId,
        storeUserName: this.$store.state.userInfo.staffName,
        storeName: this.$store.state.userInfo.storeName,
        regionName: "",
        logo: "",
        titleLogo: "",
        storeShopName:''
      },
      shoppingCarInfo: {
        userId: this.$store.state.userInfo.staffId,
        systemType: this.$store.state.userInfo.brandId
      },
      shoppingCar: false,
      shoppingList: [],
      shoppingCarAllPrice: 0
    };
  },
  created() {
    this.operaShowUserInfo();
    this.operaShoppingCar();
  },
  methods: {
    //处理不同门店的用户
    operaShowUserInfo() {
      if (this.userInfo.regionNo == 1) {
        if (this.userInfo.storeName.split("婷美摩力21产后恢复").length > 0) {
          this.userInfo.regionName =
            "婷美摩力21产后恢复·" +
            this.userInfo.storeName.split("婷美摩力21产后恢复")[0] +
            "店";
        } else {
          this.userInfo.regionName = this.storeName;
        }
            this.userInfo.storeShopName = "婷美摩力21产后恢复";
      } else if (this.userInfo.regionNo == 2) {
        if (this.userInfo.storeName.split("臻幼堂小儿推拿").length > 0) {
          this.userInfo.regionName =
            "臻幼堂小儿推拿·" +
            this.userInfo.storeName.split("臻幼堂小儿推拿")[0] +
            "店";
        } else {
          this.userInfo.regionName = this.userInfo.storeName;
        }
            this.userInfo.storeShopName = "臻幼堂小儿推拿";
      }
    },
    //购物车打开
    operaShowShoppingCar() {
      this.shoppingCar = !this.shoppingCar;
      this.operaShoppingCar();
    },
    //购物车
    operaShoppingCar() {
      selectShopCar(this.shoppingCarInfo).then(res => {
        this.shoppingList = res.obj;
        this.shoppingCarAllPrice = 0;
        this.shoppingList.forEach((val, index, arr) => {
          this.shoppingCarAllPrice += val.subtotal * 1;
        });
        this.shoppingCarAllPrice = shoppingPublic.computePrice(this.shoppingCarAllPrice,2)
        this.$store.commit("UPDATE_SHOPPING_CAR", res.obj.length); //购物车信息更新
      });
    },
    //刪除購物車商品
    operaShoppingCarDelete(items) {
      let productArr = [],
        deleteObj = {};
      productArr.push(items.productId);
      deleteObj.productIds = productArr;
      deleteObj.userId = this.$store.state.userInfo.staffId;
      deleteObj.systemType = this.$store.state.userInfo.brandId;
      deleteProductCar(deleteObj).then(res => {
        if (res.code == 20001) {
          this.operaShoppingCar();
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    //跳轉到購物車
    operaGoShoppingCar(){
      this.shoppingCar = false;
      this.$router.push('/shoppingMall/shoppingCar');
      
    },
    operaShoppingCars(val) {
      if (val) {
        this.operaShoppingCar();
      }
    },
    //点击其他地方关闭购物车
    operaHideShoppingCar(e) {
      let hideCar = document.getElementById("myShoppingCar");
      if (hideCar) {
        if (!hideCar.contains(event.target)) {
          this.shoppingCar = false;
        }
      }
    },
    //nav切换
    operaNav(i) {
      this.navIndex = i;
    },
    operaSearch(){
      this.$router.push('/shoppingMall/shoppingSearch');
    }
  }
};
</script>
<style type="text/css">
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.wrapt {
  width: 100%;
}
.wrap_zht {
  width: 1200px;
  margin: 0px auto;
}
.wrap {
  width: 100%;
  margin: 0px auto;
  overflow: hidden;
}
.wrap_zh {
  width: 1200px;
  margin: 0px auto;
  overflow: hidden;
}
/*顶部*/
.shopping-top {
  height: 40px;
  background: #444444;
}
.shopping-top-broadcast {
  width: 180px;
  line-height: 40px;
}
.shopping-top-broadcast img {
  padding-top: 12px;
  padding-right: 5px;
}
.shopping-top-broadcast p {
  float: left;
  font-size: 12px;
  color: #cccccc;
}
.shopping-canel {
  line-height: 40px;
  color: #ffffff;
}
.shopping-canel_user img {
  padding-top: 12px;
  padding-right: 5px;
  width: 24px;
  height: 28px;
}
.shopping-canel_user p {
  float: left;
  font-size: 14px;
  line-height: 38px;
}
.shopping-canel_out p {
  float: left;
  margin-left: 11px;
  font-size: 12px;
  line-height: 40px;
  cursor: pointer;
}
.shopping-canel_out p a {
  color: #ffffff;
}
.shopping-top_nav {
  padding-right: 58px;
  line-height: 40px;
  font-size: 12px;
  color: #cccccc;
}
.shopping-top_nav a {
  margin-left: 10px;
  margin-right: 10px;
  color: #cccccc;
}
/*logo*/
.shopping-head {
  padding-top: 23px;
  padding-bottom: 7px;
  padding-bottom: 7px;
  background: #ffffff;
}
.shopping-logos {
  width: 74px;
  height: 69px;
}
.shopping-head_logo {
  width: 480px;
}
.shopping-head_dl {
  width: 400px;
}
.shopping-head_dl dt,
.shopping-head_dl dd {
  width: 100%;
}
.shopping-head_dl dt {
  font-weight: bold;
  font-size: 28px;
  color: #333333;
}
.shopping-head_dl dd {
  font-size: 16px;
  color: #666666;
}
.shopping-search {
  margin-top: 17px;
  width: 460px;
  height: 40px;
}
.shopping-search_input {
  width: 408px;
  height: 38px;
  border: 1px solid #d5d9e3;
}
.shopping-search_input input {
  width: 100%;
  height: 36px;
  border: none;
  list-style: none;
}
.shoppin-search_btn {
  width: 50px;
  height: 40px;
}
.shoppin-search_btn button {
  padding: 0;
  width: 50px;
  height: 38px;
  text-align: center;
  background: #f83c57;
  border: none;
  border-radius: 0 !important;
}
/*导航栏*/
.nav {
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.12);
}
.nav-list {
  padding-left: 14px;
  width: 900px;
  line-height: 50px;
}
.nav-list li {
  float: left;
}
.nav-list a {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  width: 80px;
  font-size: 16px;
  color: #333333;
  text-align: center;
}
.nav-list .on a {
  height: 50px;
  font-size: 18px;
  color: #f83c57;
  font-weight: bold;
  border-bottom: 4px solid #f83c57;
}

/*导航栏-购物车部分*/
.nav-shopping-car {
  position: relative;
  min-width: 200px;
  height: 49px;
}

.nav-shopping-car_info {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 14px 18px 14px 18px;
  line-height: 22px;
  background: #ffffff;
  box-sizing: border-box;
  z-index: 1001;
  cursor: pointer;
}
.nav-shopping-car_info.on {
  border: 1px solid #d5d9e3;
  border-bottom: none;
}
.nav-shopping-car_info span {
  padding-left: 7px;
  padding-right: 7px;
  font-size: 12px;
  color: #666666;
}
.nav-shopping-car_info font {
  color: #f83c57;
}
.nav-shopping-icon {
  margin-top: 8px;
}
.nav-shopping-car_list {
  position: absolute;
  top: 50px;
  right: 0px;
  width: 300px;
  background: #ffffff;
  border: 1px solid #d5d9e3;
  z-index: 1000;
}
.nav-shopping-car_list-ul-scrollbar {
  width: 100%;
  height: 296px;
  overflow: hidden;
}
.nav-shopping-car_list-ul {
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
}
.nav-shopping-car_list-ul-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.nav-shopping-car_list-ulli {
  display: flex;
  padding-top: 18px;
  padding-bottom: 18px;
  width: 100%;
  border-bottom: 1px solid #d5d9e3;
}
.nav-shopping-car_list-ulli:last-child {
  border-bottom: none;
}
.shopping-car-img {
  width: 52px;
  height: 34px;
}
.nav-shopping-car_list-ulli dl {
  padding-left: 10px;
  float: left;
  flex: 1;
}
.nav-shopping-car_list-ulli dl dt,
.nav-shopping-car_list-ulli dl dd {
  float: left;
  width: 100%;
}
.nav-shopping-car_list-ulli dl dt {
  font-size: 13px;
  color: #222222;
}

.nav-shopping-car_list-ulli dl dd {
  font-size: 12px;
  color: #999999;
}
.nav-shopping-car_list-ulli p {
  line-height: 34px;
  font-size: 14px;
  color: #f83c57;
}
.nav-shopping-car_list-ulli span {
  padding-left: 8px;
  padding-top: 12px;
  cursor: pointer;
}
.nav-shopping-car_list-bottom {
  padding-top: 14px;
  padding-bottom: 14px;
  width: 100%;
  height: 70px;
  background: #f6f7f9;
}
.nav-shopping-car_bot-l {
  padding-left: 15px;
}
.nav-shopping-car_bot-l dl,
.nav-shopping-car_bot-l dl dt,
.nav-shopping-car_bot-l dl dd {
  width: 150px;
}
.nav-shopping-car_bot-l dl dt {
  font-size: 12px;
  color: #999999;
}
.nav-shopping-car_bot-l dl dd {
  font-size: 18px;
  color: #f83c57;
}
.nav-shopping-car_bot-r {
  width: 132px;
  height: 42px;
}
.nav-shopping-car_bot-r a {
  width: 120px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  background: #f83c57;
  border-radius: 5px;
}
.nav-shopping-nogoods {
  padding-top: 58px;
  padding-bottom: 34px;
  width: 100%;
  text-align: center;
}

.nav-shopping-nogoodsp {
  padding-bottom: 52px;
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #a4abb6;
}
.nav-shopping-nogoods img {
  width: 150px;
  height: 145px;
}

/*底部咨询*/
.shopping-consult {
  margin-top: 40px;
  padding-top: 28px;
  padding-bottom: 22px;
  background: #ffffff;
}

.shopping-consult_customer {
  margin-right: 34px;
  width: 90px;
  height: 90px;
  border: 1px solid #f83c57;
  border-radius: 20px;
}
.shopping-consult_customer dl,
.shopping-consult_customer dl dt,
.shopping-consult_customer dl dd {
  width: 100%;
  text-align: center;
}
.shopping-consult_customer dl dt {
  padding-top: 23px;
}
.shopping-consult_customer dl dd {
  padding-top: 14px;
  font-size: 12px;
  color: #666666;
}
.shopping-consult_phone {
  margin-left: 65px;
  width: 160px;
}
.shopping-consult_phone-line {
  padding-top: 8px;
  width: 100%;
}

.shopping-consult_phone-line span {
  padding-left: 5px;
  font-size: 14px;
  color: #666666;
  font-weight: bold;
}
.shopping-consult_phone-num {
  padding-top: 5px;
  width: 100%;
}

.shopping-consult_phone-num font {
  font-size: 20px;
  color: #f83b56;
  font-weight: bold;
}
.shopping-consult_phone-time {
  width: 100%;
}
.shopping-consult_phone-time font {
  font-size: 12px;
  color: #666666;
}
.shopping-consult_wechat {
  padding-left: 137px;
}
.shopping-consult_wechat img {
  width: 90px;
  height: 90px;
}

.shopping-consult_wechat dl {
  float: left;
  padding-top: 27px;
  padding-left: 10px;
  width: 160px;
  color: #666666;
}
.shopping-consult_wechat dl dt,
.shopping-consult_wechat dl dd {
  float: left;
  width: 100%;
  font-size: 12px;
}
.shopping-consult_wechat dl dd {
  padding-top: 10px;
}
.shopping-consult_nav {
  color: #666666;
  font-size: 15px;
  line-height: 90px;
}

.shopping-consult_nav a {
  padding-left: 10px;
  padding-right: 10px;
  color: #666666;
}
/*底部备案信息*/
.shopping-footer {
  width: 100%;
  font-size: 12px;
  color: #999999;
  line-height: 60px;
  text-align: center;
  background: #444444;
}

/*首页推荐title*/
.shopping-title {
  line-height: 20px;
  padding-top: 42px;
}
.shopping-title_name {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
.shopping-title_info {
  padding-left: 16px;
  font-size: 12px;
  color: #999999;
}

/*商品+图文table展示-detail，submit*/
.shopping-detail_goods {
  margin-top: 27px;
  width: 800px;
  border: 1px solid #d5d9e3;
}
.shopping-cen {
  width: 100%;
  text-align: center;
}
.shopping-detail_goods-find {
  padding-left: 87px;
  width: 100%;
  height: 80px;
  display: flex;
}
.shopping-detail_goods-find-img {
  margin-right: 23px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.shopping-detail_goods-find img {
  max-width: 80px;
  max-height: 80px;
}

.shopping-detail_goods-find dl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}
.shopping-detail_goods-find dl dt,
.shopping-detail_goods-find dl dd {
  width: 100%;
}
.shopping-detail_goods-find dl dt {
  font-size: 16px;
  color: #444444;
}
.shopping-detail_goods-find dl font {
  margin-right: 5px;
  font-size: 12px;
  color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shopping.vue